module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/integrations/quickbooks/PaymentAccounts.ejs -->\n<table class="table table-striped table-settings js-ext">\n    <thead>\n        <tr>\n            <th width="50%">Payment Recipient</th>\n            <th>Account</th>\n        </tr>\n    </thead>\n    <tbody class="js-empty">\n        <tr><td colspan="2">\n            <h2 class="text-center">\n                An error ocurred loading this list. Please contact support to\n                get assistance.\n            </h2>\n        </td></tr>\n    </tbody>\n    <tbody class="js-model-views">\n    </tbody>\n    <tfoot>\n        <tr>\n            <td colspan="2">\n                <button type="submit" class="btn btn-primary\n                    js-save pull-right">\n                    Save\n                </button>\n            </td>\n        </tr>\n    </tfoot>\n</table>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/integrations/quickbooks/PaymentAccounts.ejs
// module id = 888
// module chunks = 1